module.exports = __webpack_public_path__ + "static/media/05_Maf_NuestroEquipo_FabioOcampo.93b93a38.jpg";